import map from './map'
import spaces from './spaces'
import spaceAssignments from './spaceAssignments'
import pins from './pins'
import updateEnforceQrCode from './updateEnforceQrCode'
import getIsFloorBookable from './getIsFloorBookable'
import fetchBookingDesks from './fetchBookingDesks'
import fetchMeetingRoom from './fetchMeetingRoom'

export default {
  map,
  spaces,
  spaceAssignments,
  pins,
  updateEnforceQrCode,
  getIsFloorBookable,
  fetchBookingDesks,
  fetchMeetingRoom,
}
